// SuggestionListState — Zustands-Kaskade unter der Filterzeile einer Vorschlagsliste: Fehler,
// Lade-Platzhalter, „Daten nicht verfügbar", „Keine Vorschläge", sonst die Liste selbst.
import React from 'react';
import { RefreshCw, SearchX, Sparkles } from 'lucide-react';
import EmptyState from '../../../ui/EmptyState';
import { errorMessage } from '../../../api/errorMessage';

/**
 * Die Reihenfolge ist Teil des Vertrags: ein Fehler schlägt den Lade-Zustand, der wiederum
 * die Angaben aus einer noch nicht eingetroffenen Antwort (`available`, `isEmpty`).
 *
 * @param {'pending'|'error'|'success'} status — Status der Vorschlags-Abfrage
 * @param {unknown} error — Fehler der Abfrage, nur bei `status === 'error'` gelesen
 * @param {boolean} available — `false`: die Themen-Daten sind auf dem Server nicht eingespielt
 * @param {boolean} isEmpty — die Antwort enthält keinen Vorschlag
 * @param {() => void} onRetry — „Erneut versuchen" des Fehler-Zustands
 * @param {React.ReactNode} skeleton — Platzhalter für `pending`; Desktop und Mobil
 *   zeigen verschiedene Raster
 * @param {React.ReactNode} children — die Liste, wenn keiner der Zustände greift
 */
export default function SuggestionListState({
  status,
  error,
  available,
  isEmpty,
  onRetry,
  skeleton,
  children,
}) {
  if (status === 'error') {
    return (
      <EmptyState
        variant="error"
        icon={RefreshCw}
        title="Vorschläge konnten nicht geladen werden"
        description={errorMessage(error, 'Bitte später erneut versuchen.')}
        onRetry={onRetry}
      />
    );
  }
  if (status === 'pending') return <>{skeleton}</>;
  if (available === false) {
    return (
      <EmptyState
        icon={Sparkles}
        title="Vorschlags-Daten nicht verfügbar"
        description="Die Themen-Daten der Karten sind auf diesem Server noch nicht eingespielt."
      />
    );
  }
  if (isEmpty) {
    return (
      <EmptyState
        variant="filter"
        icon={SearchX}
        title="Keine Vorschläge"
        description="Passe Filter oder Suche an."
      />
    );
  }
  return <>{children}</>;
}
